export default __webpack_public_path__ + "static/media/Supernova Logo.29ece5d7.png";